import React from "react";
import { Box, Grid, Stack } from "@mui/material";
import "./Header.scss";
import puravankarLogo from "../../assets/icons/purva-logo-white.png";
import ProvidentLogo from "../../assets/images/Provident Reverse logo.png";
import PurvaLandLogo from "../../assets/images/PurvaLand Master Logo reverse.png";
import kvmImage from "../../assets/images/KVN_GROUP_WHITE.png";
import { useSelector } from "react-redux";
import { COMPARE_VALUE,PROJECT_SHOW_KVM_LOGO } from "../../config/constant";
const HeaderCustomerPreview = ({ title }) => {
  const { enquiryDetails, applicantData } = useSelector(
    (state) => state.newBookingForm
  );

  const projectName = (
    enquiryDetails?.data?.projectName ||
    enquiryDetails?.data?.ProjectName ||
    applicantData?.unitDetails?.projectName ||
    ""
  ).trim();
  const isPuravankara =
    enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara;
  const isTestProject =
    isPuravankara && projectName.toLowerCase() === PROJECT_SHOW_KVM_LOGO.toLowerCase();

  const getBrandImage = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };

  return (
    <>
      <Stack
        sx={{
          backgroundColor: "#1A407D",
          position: "fixed",
          top: "0px",
          left: "0px",
          height: {
            xs: "60px",
            sm: "60px",
            md: "88px",
          },
          width: "100%",
          zIndex: 99,
          color: "#ffff",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          spacing={0}
          className="headerPLeftRight"
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            height: "100%",
            width: "100%",
            paddingLeft: {
              xs: "16px",
              sm: "16px",
              md: "7%",
            },
            paddingRight: {
              xs: "16px",
              sm: "16px",
              md: "7%",
            },
          }}
        >
          {isTestProject ? (
            <>
              <Grid item xs={2} sm={2} sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="img"
                  src={kvmImage}
                  alt="KVM Logo"
                  sx={{
                    height: { xs: "40px", sm: "40px", md: "75px" },
                    maxHeight: { xs: "36px", sm: "40px", md: "75px" },
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
              </Grid>
              <Grid item xs={8} sm={8} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Box sx={{ fontSize: { xs: "18px", sm: "22px" }, fontWeight: "500", textAlign: "center" }}>
                  {title || "Booking Application"}
                </Box>
              </Grid>
              <Grid item xs={2} sm={2} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                <Box sx={{ width: { xs: "120px", sm: "200px", md: "276px" }, maxWidth: "100%", height: { xs: "28px", sm: "32px", md: "32px" }, overflow: "hidden" }}>
                  {getBrandImage() ? (
                    <img src={getBrandImage()} alt="Logo" style={{ maxWidth: "100%", height: "100%", objectFit: "contain" }} />
                  ) : null}
                </Box>
              </Grid>
            </>
          ) : (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  fontSize: "22px",
                  fontWeight: "500",
                  textAlign: "center",
                  display: { xs: "none", sm: "block" },
                }}
              >
                {title || "Booking Application"}
              </Box>
              <Box
                sx={{
                  width: { xs: "200px", sm: "200px", md: "276px" },
                  height: { xs: "32px", sm: "32px", md: "32px" },
                  position: { xs: "relative", sm: "absolute" },
                  top: { xs: "0px", sm: "15px", md: "30px" },
                  right: 0,
                  overflow: "hidden",
                  textAlign: "right",
                }}
              >
                {getBrandImage() ? (
                  <img src={getBrandImage()} alt="Logo" style={{ maxWidth: "100%", height: "100%", objectFit: "contain" }} />
                ) : null}
              </Box>
            </Box>
          )}
        </Grid>
      </Stack>
      <div className="extraHeight"></div>
    </>
  );
};

export default HeaderCustomerPreview;
